module.exports = __webpack_public_path__ + "img/Hotmart-4-en.91dcff7a.png";